import { useStore } from '@/state/store';
import { canEditPlaylist } from '@/storage/playlistLinks';
import { updatePlaylistScore } from '@/data/playlistScoreUpdates';
import type { TuneSourceEntry } from '@/data/tuneSources';

/** Shared recovery in the playlist page, tune browser and performance queue. */
export function PlaylistScoreUpdate({
  row,
  onUpdated,
}: {
  row: TuneSourceEntry;
  onUpdated?: () => void;
}) {
  const editable = useStore((s) =>
    row.playlistId ? canEditPlaylist(s.playlistLinks, row.playlistId) : false,
  );
  if (
    row.ref?.kind !== 'score' ||
    row.resolvable !== 'missing' ||
    !row.playlistId ||
    !row.playlistEntryId
  )
    return null;
  return (
    <div className="playlist-score-update" data-testid="playlist-score-update">
      <span>
        {row.scoreUpdate
          ? 'This saved version is no longer available.'
          : 'This score version is unavailable in this app. Refresh to check for updates.'}
      </span>
      {row.scoreUpdate && editable ? (
        <button
          type="button"
          className="btn btn-sm"
          aria-label={`Use latest version of ${row.title}`}
          onClick={() => {
            if (updatePlaylistScore(row.playlistId!, row.playlistEntryId!)) onUpdated?.();
          }}
        >
          Use latest version
        </button>
      ) : row.scoreUpdate ? (
        <span>Ask the owner to update it, or duplicate this playlist to update your copy.</span>
      ) : null}
    </div>
  );
}
